import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index'),
    meta: {
      title: "拼词之星",
      requireLogin: false,
    },
    // children:[

    // ]
  },
  // 微信分享
  {
    path: '/share',
    name: 'share',
    meta: {
      title: "",
    },
    component: () => import('../views/share')
  },
  // 隐私政策
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    meta: {
      title: "隐私政策",
    },
    component: () => import('../views/privacyPolicy')
  },
  // 用户协议
  {
    path: '/userAgreement',
    name: 'userAgreement',
    meta: {
      title: "用户协议",
    },
    component: () => import('../views/userAgreement')
  },
  // 证照信息
  {
    path: '/licenseInformation',
    name: 'licenseInformation',
    meta: {
      title: "",
    },
    component: () => import('../views/licenseInformation')
  },
  // 举报反馈
  {
    path: '/feedback',
    name: 'feedback',
    meta: {
      title: "",
    },
    component: () => import('../views/feedback')
  },
  // 兑换码
  {
    path: '/qrcode',
    name: 'qrcode',
    meta: {
      title: "",
    },
    component: () => import('../views/qrCode')
  },
  // 测评结果
  {
    path: '/results',
    name: 'results',
    meta: {
      title: "",
    },
    component: () => import('../views/results')
  },
  // 699使用说明
  {
    path: '/699Introduce',
    name: '699Introduce',
    meta: {
      title: "英语学习解决方案-产品使用说明",
    },
    component: () => import('../views/699Introduce')
  },
  // 580使用说明
  {
    path: '/580Introduce',
    name: '580Introduce',
    meta: {
      title: "英语学习解决方案-产品使用说明",
    },
    component: () => import('../views/580Introduce')
  },
  // 使用说明菜单
  {
    path: '/introMenu',
    name: 'introMenu',
    meta: {
      title: "英语学习解决方案-产品使用说明",
    },
    component: () => import('../views/introMenu')
  },
]

const router = new VueRouter({
  routes
})
router.beforeEach(async (to, from, next) => {
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title;
  }
  const whiteList = []
  if (whiteList.includes(to.path)) return next()
  next()
})

export default router
